import React from 'react';
import { useHistory } from 'react-router-dom';

import { URL } from '../../constant';
import { MenuButton } from '../navigate';

function Header({ title }) {
  const history = useHistory();

  const moveLearningNote = () => {
    console.log(`***** ${title} -> 학습노트 페이지`)
    history.push(URL.COURSE_LEARNING.LEARNING_NOTE);
  };

  const onClickHeaderBack = () => {
    console.log(`***** ${title} -> 메인 페이지`)
    history.push(URL.SELECT_LEARNING)
  }

  return (
    <div className="header_top bg_white gm">
      <div className="inner">
        <div className="btns_wrap header-trans cls">
          <div className="center_wrap cls pc_w1400">
            <div className="tit_area">
              <button
                className="sky btn_exit hide_pc hide_m"
                type="button"
                onClick={onClickHeaderBack}
              >
                <img src={`${process.env.PUBLIC_URL}/static/images/icon/ic_back@2x.png`} alt="" />
              </button>
              <button
                type="button"
                className="btn_exit3 hide_pc hide_t"
                onClick={onClickHeaderBack}
              >
                <img src={`${process.env.PUBLIC_URL}/static/images/icon/ic_ar_left.svg`} alt="" />
              </button>
              <button
                className="tit_btn"
                type="button"
                onClick={onClickHeaderBack}
              >
                {title}
              </button>
            </div>
            <div className="right_area">
              <div className="menu_btn">
                <button
                  type="button"
                  className="head_btn purple"
                  onClick={moveLearningNote}
                >
                  <img
                    alt=""
                    src={`${process.env.PUBLIC_URL}/static/images/icon/ic_gm_note_2@2x.png`}
                  />
                </button>
                <MenuButton iconPath={'/static/images/icon/ic_mn_w@2x.png'}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Header;